import { LearningObjectTypes } from '@hendrx/lms/constants';
import { createContext, PropsWithChildren, useContext, useMemo } from 'react';

type LearningObjectCommonData = {
  assignmentId?: string;
  documentVersion?: number;
  learningObjectDraftId?: string;
  learningObjectSnapshotId?: string;
  learningObjectType?: LearningObjectTypes;
  themeId?: string;
};

const LearningObjectCommonDataContext = createContext<LearningObjectCommonData>({
  assignmentId: undefined,
  documentVersion: undefined,
  learningObjectDraftId: undefined,
  learningObjectSnapshotId: undefined,
  learningObjectType: undefined,
  themeId: undefined
});

export function useLearningObjectCommonData() {
  const context = useContext(LearningObjectCommonDataContext);
  return context;
}

type LearningObjectCommonDataProviderProps = PropsWithChildren<LearningObjectCommonData>;

export function LearningObjectCommonDataProvider(props: LearningObjectCommonDataProviderProps) {
  const {
    assignmentId,
    children,
    documentVersion,
    learningObjectDraftId,
    learningObjectSnapshotId,
    learningObjectType,
    themeId
  } = props;

  const value = useMemo(
    () => ({
      assignmentId,
      documentVersion,
      learningObjectDraftId,
      learningObjectSnapshotId,
      learningObjectType,
      themeId
    }),
    [assignmentId, documentVersion, learningObjectDraftId, learningObjectSnapshotId, learningObjectType, themeId]
  );

  return <LearningObjectCommonDataContext.Provider value={value}>{children}</LearningObjectCommonDataContext.Provider>;
}
